import {WidgetCard} from 'components';
import usePostBin from 'hooks/usePostBin';
import {useNonPersistentFormMethods} from 'components/forms/hooks';
import Joi from 'joi';
import {Button, FormControl, FormHelperText} from '@material-ui/core';
import {FormProvider} from 'react-hook-form';
import {Text} from 'components/forms/fields';
import {useContext, useState, useEffect} from 'react';
import {AppCtx} from 'context/AppContext';
import {useHistory} from 'react-router-dom';

const getUrl = data => {
    const href = data?.form_state_json?._ui_state?.href;
    if (!href) {
        return false;
    } else if (href?.split('.com').length > 1) {
        return href?.split('.com')?.[1];
    } else if (href?.split('localhost:3000').length > 1) {
        return href?.split('localhost:3000')?.[1];
    } else {
        return undefined;
    }
};

const InjectFrontendState = () => {
    const postBin = usePostBin();
    const [error, setError] = useState(null);
    const [state, setState] = useState(null);
    const {setSnackProps, setSnackOpen, setFormRedirect} = useContext(AppCtx);
    const history = useHistory();

    const methods = useNonPersistentFormMethods({
        initalValues: {json: ''},
        schema: {json: Joi.string().required()},
    });

    const onSubmit = data => {
        let state = {};
        try {
            state = JSON.parse(data.json);
        } catch (e) {
            if (e instanceof SyntaxError) {
                setError('Error! Data does not appear to be valid JSON.');
            } else {
                throw e;
            }
        }
        if (Object.keys(state).length) {
            setState(state);
            postBin.post(state);
        }
    };

    useEffect(() => {
        if (postBin.result) {
            setSnackProps({severity: 'success', message: 'State loaded'});
            setSnackOpen(true);
            const url = state && getUrl(state);
            if (url) {
                setFormRedirect(true);
                history.push(url.split('/')?.slice(0, 3)?.join('/'));
            }
        }
        // eslint-disable-next-line
    }, [postBin?.result, state]);

    useEffect(() => {
        if (postBin?.error) {
            setSnackProps({
                severity: 'warning',
                message: 'Something went wrong',
            });
            setSnackOpen(true);
        }
        //eslint-disable-next-line
    }, [postBin?.error]);

    return (
        <WidgetCard xs={12} title='Inject State'>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <FormControl error={!!error}>
                        <Text
                            required
                            name='json'
                            label='json'
                            onBlur={() => setError(false)}
                        />
                        {error && <FormHelperText>{error}</FormHelperText>}
                    </FormControl>
                    <Button type='submit'>Inject state</Button>
                </form>
            </FormProvider>
        </WidgetCard>
    );
};
export default InjectFrontendState;
